module.exports = __webpack_public_path__ + "img/icone-coracao-rosa.svg";